import React from 'react';
import { motion } from 'framer-motion';

const Terms = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-3xl mx-auto bg-white rounded-2xl shadow-sm p-8 border border-gray-100"
      >
        <h1 className="text-3xl font-bold text-gray-900 mb-6 border-b pb-4 text-center">Termos de Uso</h1>
        
        <div className="space-y-6 text-gray-600 leading-relaxed">
          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3">1. Aceitação dos Termos</h2>
            <p>Ao acessar e usar este site, você concorda em cumprir e estar vinculado aos seguintes termos e condições de uso. Se você não concordar com qualquer parte destes termos, não deverá utilizar nossos serviços.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3">2. Descrição do Serviço</h2>
            <p>O ConsulteSeuNome fornece uma plataforma para consulta de restrições financeiras e facilitação de negociação de dívidas. Não somos uma instituição financeira, mas sim um intermediário que auxilia na regularização de débitos.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3">3. Uso de Dados</h2>
            <p>Para realizar as consultas, solicitamos informações como CPF ou CNPJ. Você garante que as informações fornecidas são precisas e que possui autorização legal para consultar os documentos informados.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3">4. Limitação de Responsabilidade</h2>
            <p>As informações de score e dívidas são obtidas através de bureaus de crédito e fontes públicas. Não nos responsabilizamos por eventuais divergências de dados fornecidos por terceiros.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3">5. Pagamentos</h2>
            <p>Os pagamentos realizados para regularização de dívidas são processados via gateways parceiros (como HooPay). O prazo para baixa da negativação depende exclusivamente da instituição credora após a confirmação do pagamento.</p>
          </section>

          <p className="text-sm text-gray-400 mt-8 text-center italic">Última atualização: 10 de Abril de 2026</p>
        </div>
      </motion.div>
    </div>
  );
};

export default Terms;
